import axios from "axios";

// See apiClient.ts — relative "/api" in prod (same-origin via Hosting rewrite),
// REACT_APP_BACKEND_URL (emulator) in local dev.
const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? "/api";

const publicApiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export default publicApiClient;
